<script lang="ts" setup>
import { ref } from 'vue'

import HeightTransition from '../components/HeightTransition.vue'

const displayForgottenPasswordMessage = ref(false)

function toggleDisplay() {
  displayForgottenPasswordMessage.value = !displayForgottenPasswordMessage.value
}
</script>

<template>
  <div class="container-fluid">
    <div class="row g-0 align-items-start justify-content-center">
      <div class="unlogged-page-block col-10 col-md-5 col-lg-4 col-xl-3 p-0">
        <div class="unlogged-page-header">
          <div class="logo logo-large text-center">
            <img
              alt="Logo Sancare"
              src="../assets/sancare_logo.png"
            >
            <div class="logo-title mt-3">
              SANCARE
            </div>
            <div class="logo-subtitle">
              HEALTH &amp; DATA
            </div>
          </div>
        </div>
        <div>
          <router-view v-slot="{ Component }">
            <component
              :is="Component"
              class="unlogged-page-form"
            />
          </router-view>
        </div>
        <div class="unlogged-page-navigator text-center">
          <button
            type="button"
            class="btn btn-link fw-normal password-reset-btn"
            :class="{ 'arrow-down': displayForgottenPasswordMessage }"
            @click="toggleDisplay()"
          >
            Mot de passe oublié
          </button>
          <height-transition>
            <div
              v-show="displayForgottenPasswordMessage"
              class="animated-height mt-3 mb-1"
            >
              Merci de contacter votre administrateur ou le support (<a href="tel:01.84.74.32.20">01.84.74.32.20</a>)
            </div>
          </height-transition>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.password-reset-btn::after {
  content: '\2192';
  transition: transform .3s ease;
  display: inline-block;
}

.password-reset-btn.arrow-down::after {
  transform: rotate(90deg);
}
</style>
